import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaygatwaymorachi() {



    const cardData =
    {
        keyword: 'One-day Getaway Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: One-day Getaway Morachi Chincholi Pune',
        headingDescription: 'Escape the hustle of city life with a peaceful one-day getaway to Morachi Chincholi Pune, a charming agri-tourism village just 60 km from the city. Known as the “Village of Peacocks,” Morachi Chincholi offers a refreshing rural experience with lush farms, traditional Maharashtrian food, and abundant peacock sightings. Perfect for families, kids, school groups, and corporate outings, this eco-tourism hotspot blends nature, culture, and relaxation in one scenic package. Enjoy bullock cart rides, tractor tours, organic farm visits, and rural games—all set in a serene village atmosphere. Whether you are looking for a nature retreat or a fun-filled day trip near Pune, Morachi Chincholi is the ideal destination for a rejuvenating one-day escape surrounded by greenery and authentic village hospitality.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Start with an Early Morning Drive from Pune",
    "description": "Morachi Chincholi is located just 55 km from Pune and takes around 1.5 to 2 hours by car. A scenic rural route leads you to this peacock village, perfect for a quick nature escape without long travel."
  },
  {
    "title": "Peacock Watching in Natural Habitat",
    "description": "Begin your day with a peaceful walk among ancient tamarind trees where over 2,000 peafowls roam freely. Early mornings are ideal to watch them dance, feed, and call — a truly magical experience."
  },
  {
    "title": "Traditional Maharashtrian Breakfast",
    "description": "Relish a hearty breakfast with freshly made poha, upma, misal, or puri-bhaji along with hot tea or sugarcane juice. Meals are served in a rural-style dining setup with organic, farm-fresh ingredients."
  },
  {
    "title": "Adventure Games & Rural Activities",
    "description": "Try out zip-lining, rope balancing, archery, and outdoor games like cricket, volleyball, and badminton. Also engage in bullock cart rides, tractor rides, and village-style gilli-danda or lagori."
  },
  {
    "title": "Rain Dance & Water Park Fun",
    "description": "Cool off in the water park with a large pool, rain dance area, and slides. Great for families, especially during summer and festive weekends. Dance to DJ beats under splashing showers!"
  },
  {
    "title": "Visit the On-Site Farm & Nursery",
    "description": "Explore the resort’s organic farm and nursery where seasonal fruits, vegetables, and medicinal plants are grown. A guided walk reveals traditional irrigation, composting, and rural farming methods."
  },
  {
    "title": "Magic Show, Puppet Theatre & Cultural Activities",
    "description": "Afternoons are filled with family-friendly fun such as live magic shows, puppet performances, local storytelling, and cultural skits — designed to entertain both kids and adults."
  },
  {
    "title": "Traditional Lunch Served on Banana Leaf",
    "description": "Enjoy an unlimited rural lunch including dishes like zunka-bhakar, pitla, seasonal bhaji, puran poli, rice, dal, buttermilk, and pickles — served hot and fresh in traditional Maharashtrian style."
  },
  {
    "title": "Sunset Walk or Bonfire (Optional)",
    "description": "If staying into the evening, enjoy a golden hour walk through the nearby farms or arrange a pre-booked bonfire session with music and snacks — ideal for groups and couples."
  },
  {
    "title": "Return to Pune with Memories",
    "description": "Wrap up your rejuvenating one-day escape with relaxed countryside vibes, unique memories, and vibrant photos of peacocks, rural fun, and family bonding — back to Pune by 7–8 PM."
  }
],




"services": [
  {
    "name": "Popular Tourist Spots in Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra ranks high among the most popular tourist spots in Morachi Chincholi, thanks to its serene rural setup, traditional farming experiences, and up-close encounters with peacocks and village life. It's perfect for a one-day immersive escape from the city."
  },
  {
    "name": "Bird Sanctuary Attractions",
    "description": "Located in the peacock belt of Morachi Chincholi, Anand Krushi Paryatan Kendra offers daily sightings of Indian Peafowls in their natural habitat. Visitors can enjoy early morning walks to observe and photograph these beautiful birds amidst a lush, peaceful farm landscape."
  },
  {
    "name": "Farm Tourism Activities",
    "description": "From vegetable picking and bullock cart rides to hands-on farming, Anand Krushi Paryatan Kendra offers interactive farm tourism activities ideal for families, school groups, and urban dwellers curious about village life. The experience is both fun and educational."
  },
  {
    "name": "Adventure Zones in Morachi Chincholi",
    "description": "For those seeking light adventure, Anand Krushi Paryatan Kendra provides rural-themed challenges such as rope balancing, climbing frames, and traditional village sports. These activities offer a rustic twist on modern adventure zones in a natural setting."
  },
  {
    "name": "Eco-Tourism Centers",
    "description": "As a model eco-tourism destination near Pune, Anand Krushi Paryatan Kendra promotes sustainability through organic farming, waste composting, and water conservation. It’s a great visit for conscious travelers seeking an earth-friendly rural experience."
  },
  {
    "name": "Wildlife Viewing Areas",
    "description": "Apart from peacocks, the farm is home to several native bird species, butterflies, and small mammals. Visitors can take slow nature walks through fields and tree groves for casual wildlife viewing without needing to travel to a formal sanctuary."
  },
  {
    "name": "Local Cultural Festivals",
    "description": "Anand Krushi Paryatan Kendra celebrates local festivals like Makar Sankranti, Holi, and Diwali with traditional village flair. Guests during festival weekends can enjoy folk dances, traditional games, rangoli making, and authentic Maharashtrian food."
  },
  {
    "name": "Nature Trails and Walks",
    "description": "Take a break with peaceful walks through mango orchards, vegetable gardens, and shaded trails. These nature walks at Anand Krushi Paryatan Kendra are perfect for reconnecting with nature while observing seasonal flora and fauna."
  },
  {
    "name": "Photography Hotspots",
    "description": "Photographers love Anand Krushi Paryatan Kendra for its colorful rural scenes, candid moments with animals, and of course, majestic peacocks in full feather. Golden hour shots amidst the fields are especially popular among visitors and influencers."
  },
  {
    "name": "Camping Sites",
    "description": "While Anand Krushi Paryatan Kendra primarily offers day visits, it also facilitates basic camping on request. Camp under the stars in safe, open farm surroundings and enjoy a rustic overnight experience with bonfire activities and traditional food."
  },
  {
    "name": "Food and Local Cuisine Spots",
    "description": "Taste rural Maharashtra at its finest with traditional meals served at Anand Krushi Paryatan Kendra. Dishes include bhakri, pitla, varan-bhat, chutneys, and seasonal mango delights like aamras—all cooked using locally grown ingredients on wood-fired stoves."
  },
  {
    "name": "Guided Tours in Morachi Chincholi",
    "description": "Learn about rural life and sustainable farming practices with guided tours at Anand Krushi Paryatan Kendra. Hosts walk you through the fields, explain crop cycles, and even let you try your hand at traditional farming tools and irrigation methods."
  },
  {
    "name": "Family Outing Destinations",
    "description": "Safe, scenic, and activity-filled—Anand Krushi Paryatan Kendra is a top family outing spot near Morachi Chincholi. With kid-friendly games, animal interactions, shaded seating, and delicious meals, families can enjoy quality time without screens or stress."
  },
  {
    "name": "Educational Tours for Kids",
    "description": "Schools often organize day trips to Anand Krushi Paryatan Kendra to teach children about agriculture, sustainability, and biodiversity. Kids get to experience the origin of their food, engage in hands-on learning, and have a lot of fun doing it."
  },
  {
    "name": "Historical Landmarks",
    "description": "While Anand Krushi Paryatan Kendra is not a historical site itself, it’s located within driving distance of historical landmarks like Shivneri Fort and Bhuleshwar Temple. Combine a heritage visit with a refreshing farm lunch for a balanced day trip."
  }
],
"tableData": [
  ["Popular Tourist Spots in Morachi Chincholi", "- Bird Sanctuary Attractions"],
  ["Farm Tourism Activities", "- Adventure Zones in Morachi Chincholi"],
  ["Eco-Tourism Centers", "- Wildlife Viewing Areas"],
  ["Local Cultural Festivals", "- Nature Trails and Walks"],
  ["Photography Hotspots", "- Camping Sites"],
  ["Food and Local Cuisine Spots", "- Guided Tours in Morachi Chincholi"],
  ["Family Outing Destinations", "- Educational Tours for Kids"],
  ["Historical Landmarks", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Close to Pune for a Quick Escape",
    "WhyChoosedescription": "Morachi Chincholi is just about 55 km from Pune, making it a perfect destination for a refreshing one-day getaway. The short drive offers beautiful countryside views and a break from city life."
  },
  {
    "WhyChooseheading": "Experience the Famous Peacock Sanctuary",
    "WhyChoosedescription": "Known as the 'Village of Peacocks,' Morachi Chincholi boasts thousands of peacocks freely roaming its ancient tamarind groves. Witness their mesmerizing dances and vibrant plumage in a natural setting."
  },
  {
    "WhyChooseheading": "Fun Farm and Village Activities",
    "WhyChoosedescription": "Enjoy activities like bullock cart rides, tractor tours, feeding farm animals, and vegetable picking. These hands-on experiences provide an authentic rural vibe for visitors of all ages."
  },
  {
    "WhyChooseheading": "Adventure and Entertainment for All Ages",
    "WhyChoosedescription": "From zip-lining, archery, and boating to puppet shows and magic performances, there’s plenty of fun to keep both kids and adults engaged throughout the day."
  },
  {
    "WhyChooseheading": "Seasonal Festivals and Cultural Celebrations",
    "WhyChoosedescription": "Time your visit to coincide with local festivals like the Mango Mahotsav or Hurda parties to enjoy traditional food, cultural programs, and vibrant village celebrations."
  },
  {
    "WhyChooseheading": "Delicious Local Cuisine and Farm-to-Table Dining",
    "WhyChoosedescription": "Savor fresh, organic meals prepared with local ingredients, offering authentic Maharashtrian flavors and a wholesome dining experience."
  },
  {
    "WhyChooseheading": "Suitable for Families, Friends, and Corporate Groups",
    "WhyChoosedescription": "Whether it’s a family outing, friends’ day trip, or corporate team-building event, Morachi Chincholi offers something for everyone in a peaceful natural setting."
  },
  {
    "WhyChooseheading": "Affordable and Convenient Packages",
    "WhyChoosedescription": "With budget-friendly packages including meals, activities, and guided tours, Morachi Chincholi is an accessible and value-packed day trip option near Pune."
  }
]








    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Is Morachi Chincholi suitable for a one-day getaway from Pune?',
    answer: 'Absolutely! Morachi Chincholi is just about 65 km from Pune and offers a perfect blend of nature, rural charm, and fun activities for a refreshing one-day escape.',
  },
  {
    id: 'FAQ2',
    question: 'What activities can we enjoy during a one-day trip?',
    answer: 'You can experience peacock sightings, farm rides like bullock carts and tractors, butterfly watching, nature walks, and enjoy local Maharashtrian cuisine.',
  },
  {
    id: 'FAQ3',
    question: 'Are there food facilities available on-site?',
    answer: 'Yes, many agritourism centers provide farm-to-table meals and snacks made from fresh local produce.',
  },
  {
    id: 'FAQ4',
    question: 'What is the best time of year for a one-day visit?',
    answer: 'Monsoon through early winter (June to November) is ideal for weather and for seeing peacocks at their best.',
  },
  {
    id: 'FAQ5',
    question: 'Can families with children enjoy the trip?',
    answer: 'Definitely. The activities are family-friendly, educational, and entertaining for children and adults alike.',
  },
  {
    id: 'FAQ6',
    question: 'How do we reach Morachi Chincholi from Pune?',
    answer: 'It is easily accessible by car or taxi via Alandi or Chakan, with good roads and clear signage.',
  },
  {
    id: 'FAQ7',
    question: 'Are restroom and other facilities available for visitors?',
    answer: 'Yes, most spots offer clean restrooms and resting areas to ensure a comfortable visit.',
  },
  {
    id: 'FAQ8',
    question: 'Is prior booking required for a one-day visit?',
    answer: 'Booking is recommended during weekends and holidays to secure your spot, especially for group activities.',
  },
  {
    id: 'FAQ9',
    question: 'Can we combine this trip with visits to nearby attractions?',
    answer: 'Yes, you can include nearby places like Ranjangaon Ganpati Temple and Alandi for a full-day cultural and nature experience.',
  },
  {
    id: 'FAQ10',
    question: 'What should we carry for the trip?',
    answer: 'Carry comfortable clothing, hats, water bottles, insect repellent, and cameras for a pleasant experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Desai, Pune',
    feedback: "Our one-day getaway to Morachi Chincholi was rejuvenating. The peacock sightings and rural activities were unique and fun for the whole family.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Sharma, Mumbai',
    feedback: "I loved the peacefulness of Morachi Chincholi. The farm-to-table food was delicious, and the nature walks were refreshing. Perfect one-day escape from Pune’s hustle.",
    rating: 5,
  },
];








    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One-day Getaway Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/one-day-getaway-morachi-chincholi.jpg",
  "description": "Enjoy a perfect one-day getaway at Morachi Chincholi near Pune. Discover romantic escapes, nature retreats, family fun, and peaceful countryside experiences at Anand Krushi Paryatan Kendra — ideal for all types of travelers.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2097"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "600",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/one-day-getaway-morachi-chincholi"
  }
};




    return (
        <div>
<Helmet>
  <title>One-day Getaway Morachi Chincholi Pune | Nature, Romance & Family Fun | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Plan your one-day getaway to Morachi Chincholi near Pune. Explore countryside retreats, romantic escapes, family adventures, and relaxing farm experiences at Anand Krushi Paryatan Kendra." 
  />
  <meta 
    name="keywords" 
    content="Quick escape spots near Morachi Chincholi, Weekend getaway ideas from Morachi Chincholi, Romantic one-day getaways near Morachi Chincholi, Nature retreats close to Morachi Chincholi, Family-friendly day getaways, Adventure day trips near Morachi Chincholi, Peaceful countryside getaways, Budget-friendly one-day trips, Luxury one-day retreats, Picnic getaway locations, One-day farm stays near Morachi Chincholi, Cultural getaway spots nearby, Relaxing day trip destinations, Wellness day getaways, Scenic drives from Morachi Chincholi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/7.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onewaygatwaymorachi;